export default __webpack_public_path__ + "static/media/iconmonstr.49487f0e.webp";